export default __webpack_public_path__ + "static/media/Bank_Of_China_logo.c483b61f.png";